import { render, staticRenderFns } from "./PersonalCard.vue?vue&type=template&id=3281a5b0&"
import script from "./PersonalCard.ts?vue&type=script&lang=ts&"
export * from "./PersonalCard.ts?vue&type=script&lang=ts&"
import style0 from "./PersonalCard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports